import React from "react";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { ClientNotificationFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { NotificationFilterStore } from "../../Store/Variable";
import { NotificationFilterForm } from "./NotificationFilterForm";

interface INotificationFilterProps {
    currentFilter: ClientNotificationFiltersModel;
    onApply: (filter: ClientNotificationFiltersModel) => void;
    onCancel: () => void;
}

interface INotificationFilterState {}

export class NotificationFilter extends FormComponent<INotificationFilterProps, INotificationFilterState> {
    constructor(props: INotificationFilterProps) {
        super(props);
        this.state = {};
    }

    private form = null;

    public render() {
        return (
            <div>
                <h3 className="text-size-16 text-bold">Filter</h3>
                <NotificationFilterForm
                    currentFilter={this.props.currentFilter}
                    onRef={(ref) => {
                        this.form = ref;
                    }}
                    isLightbox={false}
                />
                <div className="row">
                    <div className="col-auto">
                        <button
                            className="btn secondary mr-12"
                            onClick={() => {
                                this.props.onCancel();
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn primary"
                            onClick={() => {
                                if (this.form && this.form.isValid()) {
                                    this.props.onApply(this.form.getData());
                                }
                            }}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
